<script setup lang="ts">
interface MenuITem {
  label: string
  icon?: string
  to: string
  externalLink?: boolean
}

interface Props {
  items: MenuITem[]
}

const props = defineProps<Props>()
</script>

<template>
  <div class="divide-y divide-primary-100/20">
    <template
      v-for="(opt, i) in props.items"
      :key="i"
    >
      <div class="px-2 py-3 md:py-4 w-full hover:bg-[rgb(255,255,255)]/20 cursor-pointer">
        <PvButton
          unstyled
          as="a"
          @click="
            navigateTo(opt.to, {
              external: true,
              open: opt.externalLink ? { target: '_blank' } : undefined,
            })
          "
        >
          <div class="flex gap-4 text-current text-left">
            <div class="text-2xl hidden md:flex items-center">
              <span
                v-if="opt.icon"
                class="accent text-primary"
                :class="getIconClass(opt.icon)"
              />
            </div>
            <div class="text-sm md:text-base text-center md:text-left w-full leading-tight">
              {{ opt.label }}
            </div>
          </div>
        </PvButton>
      </div>
    </template>
  </div>
</template>
